export interface RiskScoreSlice {
  riskPage: number;
  riskModelName: string;

  setRiskPage: (page: number) => void;
  setRiskModelName: (modelName: string) => void;
}

export const createRiskScoreSlice = (set: any): RiskScoreSlice => ({
  riskPage: 1,
  riskModelName: "",

  setRiskPage: (riskPage) => set({ riskPage }),
  setRiskModelName: (riskModelName) => set({ riskModelName, riskPage: 1 }),
});
